import { useMutation } from '@tanstack/react-query'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import type { IGenerateTwoFaCodeRequest } from '~/@api/generated-api-types-user/Api'

function useTwoFa() {
  const client = useApiClientUser()

  const generateTwoFaCodeMutation = useMutation({
    mutationFn: async (payload: IGenerateTwoFaCodeRequest) => {
      return client.user
        .twoFaCodeControllerGenerate(payload, {
          secure: true,
        })
        .then((res) => res.data)
    },
  })

  return {
    generateTwoFaCode: generateTwoFaCodeMutation.mutate,
    isGeneratingTwoFaCode: generateTwoFaCodeMutation.isPending,
    twoFaCodeExpiresAt: generateTwoFaCodeMutation?.data?.expiresAt
      ? new Date(generateTwoFaCodeMutation?.data?.expiresAt)
      : null,
    error:
      getApiErrorMessage(
        generateTwoFaCodeMutation.error,
        'SMS kód sa nepodarilo odoslať.'
      ) ?? undefined,
  }
}

export { useTwoFa }
